module.exports = __webpack_public_path__ + "static/media/toptaskanalysis.d431f342.pdf";